import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'semantic-ui-react';
import styles from './HelpModal.module.scss';

const HelpModal = ({ trigger, agency, title, children, policyNumber, message }) => {
    const emails = useMemo(() => {
		let _emails = agency.emails || [];
		return _emails;
	}, [agency]);

	const phones = useMemo(() => {
		let _phones = (agency.producer || agency).phones || [];
		if (_phones.length === 0) {
			_phones = agency.phones || [];
		}
		return _phones;
	}, [agency]);

	const [open, setOpen] = useState(false);

    return (
        <Modal size='tiny' trigger={trigger} open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)}>
			<Modal.Header>{title || "Help"}</Modal.Header>
			<Modal.Content>
				<div>{children || message || `For help with making changes to your policy${(policyNumber ? ` (${policyNumber})` : '')} please contact your agent.`}</div>
				<div className={styles.center}>
					<div>
						<b>Agency Information</b>
					</div>
					<div>{agency.displayName}</div>
					{agency.producer && <div>{agency.producer.displayName}</div>}
					<div>{agency.addressLine1}</div>
					<div>{agency.addressLine2}</div>
					<div>{phones[0]}</div>
					<div><a href={`mailto:${emails[0]}`} target="_blank" rel="noopener noreferrer">{emails[0]}</a></div>
				</div>
			</Modal.Content>
			<Modal.Actions>
				<Button id="closeBtn" primary onClick={() => setOpen(false)}>
					Close
				</Button>
			</Modal.Actions>
		</Modal>
    );
};

HelpModal.propTypes = {
    trigger: PropTypes.any.isRequired,
    agency: PropTypes.any.isRequired,
	title: PropTypes.string,
	policyNumber: PropTypes.string
};

export default HelpModal;